import React from 'react';
import __ from 'lodash';
 
class DropdownProvinsi extends React.Component{
    render(){
        return (
            this.props.provinsi.map((val) =>
                <option key={val.idProvinsi} value={val.idProvinsi}>{val.namaProvinsi}</option>
            )            
        )
    }
}

export default DropdownProvinsi;